<template>
    <div>
        <!-- UploadBox -->
        <label
            for="file-upload-input"
            class="relative font-medium text-green-600 bg-white rounded-md cursor-pointer hover:text-green-500"
        >
            <div
                ref="fileUpload"
                class="flex justify-center px-6 pt-5 pb-6 mt-2 border-2 border-gray-300 border-dashed rounded-md"
            >
                <div class="flex flex-col items-center justify-center space-y-1 text-center">
                    <FileUploadIcon />
                    <div class="flex items-center justify-center text-sm text-gray-600">
                        <span>Upload a file</span>
                        <input
                            id="file-upload-input"
                            ref="file-upload-input"
                            name="file-upload-input"
                            type="file"
                            class="sr-only"
                            :multiple="multiple"
                            @change="filesChange($event.target.files)"
                        >
                        <p class="pl-1">
                            or drag and drop
                        </p>
                    </div>
                    <p class="text-xs text-gray-500">
                        PNG, JPG, GIF up to 5MB
                    </p>
                </div>
            </div>
        </label>

        <!-- Selected images list -->
        <div class="flex w-full gap-4 mt-6">
            <div
                v-for="(file, key) in files"
                :key="'file-' + key"
                class="relative flex w-1/3 group"
            >
                <div class="absolute items-center justify-center hidden w-full h-full group-hover:flex">
                    <div class="w-full h-full bg-black rounded opacity-50" />
                    <div
                        class="absolute"
                        @click="removeFile(key)"
                    >
                        <DeleteIcon class="w-8 text-red-500 cursor-pointer fill-current" />
                    </div>
                </div>
                <img
                    :src="previewImages[key]"
                    class="object-cover object-center w-full h-full rounded"
                >
            </div>
        </div>
    </div>
</template>

<script>
import FileUploadIcon from './Icons/FileUploadIcon.vue';
import DeleteIcon from './Icons/DeleteIcon.vue';

export default {
    name: 'FileUpload',

    components: {
        FileUploadIcon,
        DeleteIcon,
    },

    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            dragAndDropCapable: false,
            files: [],
            previewImages: [],
        };
    },

    watch: {
        files: {
            deep: true,
            handler() {
                this.$emit('filesUploaded', this.files);
            },
        },
    },

    mounted() {
        this.dragAndDropCapable = this.determineDragAndDropCapable();
        if (this.dragAndDropCapable) {
            ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((evt) => {
                this.$refs.fileUpload.addEventListener(evt, (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }, false);
            });

            this.$refs.fileUpload.addEventListener('drop', (e) => {
                for (let i = 0; i < e.dataTransfer.files.length; i++) {
                    this.files.push(e.dataTransfer.files[i]);
                }
                this.getImagePreviews();
            });
        }
    },

    methods: {
        determineDragAndDropCapable() {
            const div = document.createElement('div');
            return (('draggable' in div)
                || ('ondragstart' in div && 'ondrop' in div))
                && 'FormData' in window
                && 'FileReader' in window;
        },

        getImagePreviews() {
            this.previewImages = [];
            for (let i = 0; i < this.files.length; i++) {
                if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
                    const reader = new FileReader();
                    reader.addEventListener('load', () => {
                        if (this.multiple) {
                            this.previewImages.push(reader.result);
                        } else {
                            this.previewImages = [reader.result];
                        }
                    }, false);

                    /**
                     * Read the data for the file in through the reader. When it has
                     * been loaded, we listen to the event propagated and push what
                     * was loaded from the reader to previewImages which will be rendered.
                     */
                    reader.readAsDataURL(this.files[i]);
                }
                // else {
                //     /**
                //      * We do the next tick so the reference is bound and we can access it.
                //      * then
                //      */
                //     // this.$nextTick(() => {
                //     //     this.$refs[`preview${parseInt(i)}`][0].src = '/storage/default/default.png';
                //     // });
                // }
            }
        },

        filesChange(fileList) {
            if (!fileList.length) return;
            Object.keys(fileList).forEach((key) => {
                if (this.multiple) {
                    this.files.push(fileList[key]);
                } else {
                    this.files = [fileList[0]];
                }
            });
            this.getImagePreviews();
        },

        removeFile(key) {
            this.files.splice(key, 1);
            this.previewImages.splice(key, 1);
        },
    },
};
</script>

<style scoped>
div.file-listing{
  width: 400px;
  margin: auto;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

div.file-listing img{
  height: 100px;
}

div.remove-container{
  text-align: center;
}

div.remove-container a{
  color: red;
  cursor: pointer;
}
</style>
